import ResetPassword from "@/src/screens/auth/reset-password-screen/reset-password-screen";

function ResetPasswordRoute() {
  return <ResetPassword type="reset-password" />;
}
export default ResetPasswordRoute;
